<template>
  <section class="faq-widget">
    <List :title="widget.title">
      <ListCollapseItem
        v-for="(item, index) in shownItems"
        :key="index"
        :item="item"
      />
    </List>

    <div class="grid">
      <BaseButton
        v-if="hasItemsToLoad"
        class="load-more-btn"
        color="quaternary"
        :text="t('load-more')"
        @click.stop="loadMore"
      />
    </div>
  </section>
</template>

<script lang="ts" setup>
import type { PublicFaqWidget } from '@/service/__generated-api'
import type { Widget } from '@/types/utils'

const props = defineProps<Widget<PublicFaqWidget>>()

const { t } = useI18n()

const PAGINATION_SIZE = 4

const shownItemAmount = ref(PAGINATION_SIZE)

const loadMore = () => {
  shownItemAmount.value += PAGINATION_SIZE
}

const shownItems = computed(() =>
  props.widget.items
    .map(({ answer, question }) => ({
      label: question,
      content: answer
    }))
    .slice(0, shownItemAmount.value)
)

const hasItemsToLoad = computed(
  () => props.widget.items.length > shownItemAmount.value
)
</script>

<style lang="scss" scoped>
.load-more-btn {
  @include media-column(
    (
      xs: 24,
      md: 22 1
    )
  );
  width: rem(176px);
  margin-inline: auto;
  margin-top: rem(48px);

  @include media-up(lg) {
    margin-top: rem(75px);
  }
}
</style>
